import { ModelApiService } from './BaseApiService'

export default class SubjectsApiService extends ModelApiService {
  constructor() {
    super('subjects')
  }
}
